"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const gray = {
    100: "#323232",
    90: "#484848",
    80: "#585858",
    70: "#686868",
    60: "#7A7A7A",
    50: "#8F8F8F",
    40: "#A5A5A5",
    30: "#BEBEBE",
    20: "#D5D5D5",
    10: "#E9E9E9",
    0: "#F7F7F7",
};
exports.default = gray;
//# sourceMappingURL=gray.js.map